import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BarcodePrinter from "../../core/modals/inventory/barcodePrinter";
import Axios from "axios";
import { API_BASE_URL, GET_BARCODE_TYPE } from "../../Config";
import JsBarcode from "jsbarcode";

const PrintBarcode = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const navigate = useNavigate();

  const [isStoreLoading, setIsStoreLoading] = useState(true);
  // const [isProductLoading, setIsProductLoading] = useState(false);
  const [barcodeFieldData, setBarcodeFieldData] = useState(null);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const storesData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Stores")
    );
    const productsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Products")
    );

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);

      if (storesData) {
        setStoresData(storesData);
        setIsStoreLoading(false);
      }

      if (productsData) {
        setProductsData(productsData);
      }
    } else {
      navigate("/");
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [storesData, setStoresData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductData, setSelectedProductData] = useState(null);
  const [isMRPChecked, setMRPIsChecked] = useState(true);
  const [isPriceChecked, setPriceIsChecked] = useState(true);
  const [barcodeTemplates, setBarcodeTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [barcodePreviewHtml, setBarcodePreviewHtml] = useState("");

  useEffect(() => {
    if (userDataSession?.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_BARCODE_TYPE}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status && response.data.ResultData?.length) {
            const templates = response.data.ResultData;
            setBarcodeTemplates(templates);
            setSelectedTemplate(templates[0]);
          } else {
            console.error("No barcode templates returned");
          }
        })
        .catch((error) => {
          console.error("Error fetching barcode templates:", error);
        });
    }
  }, [userDataSession]);

  const handleTemplateChange = (selectedOption) => {
    const tmpl = barcodeTemplates.find((t) => t.Id === selectedOption.value);
    setSelectedTemplate(tmpl);
  };

  // Fetch barcode fields when product is selected
  useEffect(() => {
    if (selectedProduct?.value && userDataSession?.OrgId) {
      const productId = selectedProduct.value; // This is ItemId from filteredDDLData_Products
      Axios.get(
        `${API_BASE_URL}Product/GetBarcodeFields?OrgId=${
          userDataSession.OrgId
        }&ProductId=${productId}&StoreId=${selectedStore?.value || 0}`
      )
        .then((res) => {
          if (res.data.Status && res.data.ResultData?.length) {
            setBarcodeFieldData(res.data.ResultData[0]);
          } else {
            setBarcodeFieldData(null);
          }
        })
        .catch((err) => {
          console.error("Error fetching barcode fields:", err);
          setBarcodeFieldData(null);
        });
    } else {
      setBarcodeFieldData(null);
    }
  }, [selectedProduct, userDataSession, selectedStore]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const generateBarcodeContent = (item, autoPrint = false) => {
    if (!item && !barcodeFieldData) {
      alert("Please select a valid product with barcode data.");
      return;
    }

    const templateHtml =
      selectedTemplate?.HtmlString || barcodeTemplates[0]?.HtmlString;
    if (!templateHtml) {
      alert("No barcode template available.");
      return;
    }

    const data = barcodeFieldData || item;

    try {
      const tempSvg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      tempSvg.setAttribute("ref", "tempBarcode");
      document.body.appendChild(tempSvg);

      JsBarcode(tempSvg, data.Barcode || item?.BarCode, {
        format: "CODE128",
        lineColor: "#000",
        width: 2,
        height: 40,
        displayValue: true,
      });

      setTimeout(() => {
        const barcodeSVG = tempSvg.outerHTML.replace(
          "<svg",
          '<svg width="450px" height="90px"'
        );

        const mrp = parseFloat(data.MRP) || 0;
        const storePrice = parseFloat(data?.StorePrice) || 0;
        const discountPercent =
          data["Discount%"] ??
          (mrp > 0 ? Math.round(((mrp - storePrice) / mrp) * 100) : 0);
        const formattedDiscount = `${discountPercent}%`;

        const printContent = templateHtml
          .replaceAll(
            "#ORGNAME#",
            data?.OrgName || userDataSession?.BusinessName || ""
          )
          .replaceAll("#ITEMNAME#", data?.ProductName || "")
          .replaceAll("#WEIGHT#", data?.Weight ?? "N/A")
          .replaceAll("#UNITS#", data?.Units ?? "")
          .replaceAll("#MFGDATE#", formatDate(data?.MfgDate) || "")
          .replaceAll("#EXPIRYDATE#", formatDate(data?.ExpiryDate) || "")
          .replaceAll(
            "#PHNO#",
            data?.StorePhoneNo || userDataSession?.Phone || ""
          )
          .replaceAll("#ITEMPRICE#", mrp)
          .replaceAll("#MRPPRICE#", mrp)
          .replaceAll("#STOREPRICE#", storePrice?.toFixed(2))
          .replaceAll("#DISCOUNT#", formattedDiscount || "0%")
          .replaceAll("#DISCPERCENT#", data?.Discount  || "")
          .replaceAll("#DISCAMOUNT#", data?.DiscountedPrice || "")
          .replaceAll("#FINALAMOUNT#", storePrice)
          .replaceAll("#BARCODEIMG#", barcodeSVG);

        document.body.removeChild(tempSvg);

        if (autoPrint) {
          const printWindow = window.open("", "_blank");
          if (!printWindow) {
            console.error("Failed to open print window.");
            return;
          }
          console.log("printContent", printContent);
          printWindow.document.write(printContent);
          printWindow.document.close();
          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }, 500);
        } else {
          setBarcodePreviewHtml(printContent);
        }
      }, 300);
    } catch (error) {
      console.error("Error generating barcode content:", error);
      alert("Failed to generate barcode. Please check the product data.");
    }
  };

  const handleGenerateBarcode = () => {
    generateBarcodeContent(selectedProductData, false);
  };

  const handlePrintBarcode = () => {
    generateBarcodeContent(selectedProductData, true);
  };

  useEffect(() => {
    const product = productsData.find(
      (item) => item.ItemId === selectedProduct?.value
    );
    setSelectedProductData(product);
  }, [selectedProduct, productsData]);

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  const handleMRPCheckboxChange = (event) => {
    setMRPIsChecked(event.target.checked);
  };

  const handlePriceCheckboxChange = (event) => {
    setPriceIsChecked(event.target.checked);
  };

  return (
    <div className="page-wrapper notes-page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Print Barcode</h4>
              <h6>Manage your barcodes</h6>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
        </div>
        <div className="barcode-content-list">
          <form>
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="row seacrh-barcode-item">
                  {/* Store Dropdown */}
                  <div className="col-sm-6 col-lg-3 col-md-3 mb-3 seacrh-barcode-item-one">
                    <label className="form-label">Store</label>
                    <div className="input-bloks">
                      {isStoreLoading ? (
                        <div className="d-flex justify-content-center align-items-center p-2">
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Loading stores...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Select
                          className="select"
                          id="storeSelect"
                          onChange={handleStoreChange}
                          options={storesData.map((store) => ({
                            value: store.ItemId,
                            label: store.ItemValue,
                          }))}
                          placeholder="Choose store"
                          isLoading={isStoreLoading}
                        />
                      )}
                    </div>
                  </div>

                  {/* Category Dropdown - Hidden with d-none */}
                  <div className="col-sm-6 col-lg-3 col-md-3 seacrh-barcode-item-one d-none">
                    <label className="form-label">Category</label>
                    <div className="input-bloks">
                      <Select
                        className="select"
                        placeholder="Choose Category"
                      />
                    </div>
                  </div>

                  {/* Product Dropdown */}
                  <div className="col-sm-6 col-lg-3 col-md-3 seacrh-barcode-item-one">
                    <label className="form-label">Product</label>
                    <div className="input-bloks">
                      {productsData.length === 0 ? (
                        <div className="d-flex justify-content-center align-items-center p-2">
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Loading products...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Select
                          className="select"
                          id="productSelect"
                          value={selectedProduct}
                          onChange={handleProductChange}
                          options={productsData.map((item) => ({
                            value: item.ItemId,
                            label: item.ItemValue || item.DisplayValue,
                          }))}
                          placeholder="Choose Product"
                        />
                      )}
                    </div>
                  </div>

                  {/* Barcode Template */}
                  <div className="col-sm-6 col-lg-3 col-md-3 seacrh-barcode-item-one ">
                    <label className="form-label mb-0">
                      Barcode Template
                      <Link
                        to="#"
                        className="btn btn-sm rounded-circle btn-outline-secondary ms-2 "
                        onClick={handleGenerateBarcode}
                      >
                        <i className="fas fa-question fa-bounce" />
                      </Link>
                    </label>
                    <div className="input-bloks">
                      {barcodeTemplates.length === 0 ? (
                        <div className="d-flex justify-content-center align-items-center p-2">
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Loading templates...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Select
                          className="select"
                          id="templateSelect"
                          value={
                            selectedTemplate
                              ? {
                                  value: selectedTemplate.Id,
                                  label: selectedTemplate.BarcodeName,
                                }
                              : null
                          }
                          onChange={handleTemplateChange}
                          options={barcodeTemplates.map((t) => ({
                            value: t.Id,
                            label: t.BarcodeName,
                          }))}
                          placeholder="Choose Template"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          {barcodePreviewHtml && (
            <div className="row">
              <div className="barcode-preview mt-4 p-3 align-center col-5">
                <div className="d-flex justify-content-between  mb-2">
                  <h5 className="mb-0">Barcode Preview</h5>
                  <button
                    className="btn btn-sm "
                    onClick={() => setBarcodePreviewHtml("")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <div
                  className="preview-content"
                  dangerouslySetInnerHTML={{ __html: barcodePreviewHtml }}
                  style={{
                    background: "#fff",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    overflow: "auto",
                  }}
                />
              </div>
            </div>
          )}

          <div className="paper-search-size">
            <div className="row align-items-center">
              <div className="col-lg-6 pt-3">
                <div className="row">
                  <div className="col-sm-4 d-none">
                    <div className="search-toggle-list">
                      <p>Show MRP</p>
                      <div className="input-blocks m-0">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <input
                            type="checkbox"
                            id="user7"
                            className="check"
                            checked={isMRPChecked}
                            onChange={handleMRPCheckboxChange}
                          />
                          <label
                            htmlFor="user7"
                            className="checktoggle mb-0"
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 d-none">
                    <div className="search-toggle-list">
                      <p>Show Our Price</p>
                      <div className="input-blocks m-0">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <input
                            type="checkbox"
                            id="user8"
                            className="check"
                            checked={isPriceChecked}
                            onChange={handlePriceCheckboxChange}
                          />
                          <label htmlFor="user8" className="checktoggle mb-0">
                            {" "}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="search-barcode-button">
            <button
              onClick={handleGenerateBarcode}
              className="btn btn-submit me-2 d-none"
            >
              <span>
                <i className="fas fa-eye me-2" />
              </span>
              Generate Barcode
            </button>
            <Link to="#" className="btn btn-cancel me-2 d-none">
              <span>
                <i className="fas fa-power-off me-2" />
              </span>
              Reset Barcode
            </Link>
            <button
              onClick={handlePrintBarcode}
              className="btn btn-cancel close-btn"
              disabled={!selectedStore || !selectedProduct}
            >
              <span>
                <i className="fas fa-print me-2" />
              </span>
              Print Barcode
            </button>
          </div>
        </div>
      </div>
      <BarcodePrinter />
    </div>
  );
};

export default PrintBarcode;
